module.exports = __webpack_public_path__ + "img/loyalty.79badaff.png";